import { tv } from '@change/ds-utils';

export const actionButton = tv({
	base: 'rounded-medium px-4 py-2',
	compoundVariants: [
		{
			// Classes to simulate the primary button from legacy DS
			class:
				'text-typography-inverse-strong! bg-[#E01A2B]! before:border-none! hover:bg-[#B71523]! before:hover:border-2! before:hover:border-solid! before:hover:border-black! active:bg-[#B71523]! before:active:border-2! before:active:border-solid! before:active:border-black!',
			actionType: 'shareExperimental',
		},
		{
			// Height follows the tallest label in the toolbar (parent flex + items-stretch);
			// min-h-9 keeps a sensible floor when copy is short.
			class: '*:text-size-body-small h-auto min-h-9 min-w-[104px] self-stretch *:font-bold',
			variant: 'default',
		},
		{
			class: '*:text-size-body-bold h-auto min-h-12 max-w-5xl self-stretch py-3 pr-4 pl-3',
			variant: 'inline',
		},
		{
			class:
				'*:text-size-body-xs min-h-14 flex-1 flex-col justify-start gap-0.5 px-2 *:leading-4 [&>div]:flex [&>div]:h-8 [&>div]:items-center [&>div]:justify-center',
			variant: 'square',
		},
	],
	variants: {
		variant: {
			default: '',
			inline: '',
			square: '',
		},
		actionType: {
			edit: '',
			link: '',
			view: '',
			share: '',
			shareExperimental: '',
		},
	},
});
